export default __webpack_public_path__ + "static/media/logo_aishipr.7b94d274.png";